import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoginService } from '../services/login.service';

export const httpHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loginService = inject(LoginService)

  const token = loginService.getToken()
  const apisecret = loginService.getApiSecret()
  const emailUsuario = loginService.getUsuario()

    const request = token ? req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`).set('client-secret-key', apisecret || '').set('email-usuario', emailUsuario)
    }) : req.clone({})

    return next(request);
};
